module.exports = __FOREMAN_VENDOR__HUMANIZE_DURATION__;